import React from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useOrganization, useUserList } from 'src/core/graphql/hooks'
import UserListItemDetailsCard from 'src/sites/kits/People/components/UserListItemDetailsCard'
import { useGlobalState } from 'src/sites/state'

const PeopleAsideBlock = ({ badgeId }) => {
   const { theme } = useGlobalState()
   const targetType = 'organization'
   const targetId = 'current'

   const { organization } = useOrganization()
   const showMembers = organization.memberListEnabled

   const userFilter = {
      limit: 5,
      userRelationshipFilter: {
         entityType: targetType,
         entityId: targetId
      },
      withRelationship: false,
      withRelationshipEntityType: targetType,
      withRelationshipEntityId: targetId
   }

   if (badgeId) {
      userFilter.userRelationshipFilter.hasBadgeId = badgeId
   } else {
      userFilter.userRelationshipFilter.hasRoleParticipantElement = {
         roleType: showMembers ? 'primary' : 'admin',
         status: 'active'
      }
   }

   const { userList } = useUserList(userFilter)

   if (userList.items.length === 0) {
      return null
   }

   return (
      <>
         {!badgeId && (
            <>
               <Text size="3" weight="medium" color={theme.tmpContentTitleColor}>
                  {`Community ${showMembers ? 'Members' : 'Admins'} `}
               </Text>
               <View padding="15px 0px 30px 0px">
                  <Text size="2" color="#777">
                     {showMembers ? 'Connect with these members' : 'Reach out to these admins'}
                     {` of the ${organization.name} Community.`}
                  </Text>
               </View>
            </>
         )}
         <View marginBottom="20px">
            <Grid columns="1" spacing="20px">
               {userList.items.map(user => (
                  <GridCell key={user.id}>
                     <UserListItemDetailsCard
                        id={user.id}
                        avatarMedia={user.avatarMedia}
                        avatarSize="30px"
                        badges={user.badges}
                        fullName={user.fullName}
                        organization={user.organization}
                        position={user.position}
                     />
                  </GridCell>
               ))}
            </Grid>
         </View>
         {showMembers && (
            <View width="100%" display="block">
               <Link to="/-/people">
                  <Text size="2" color="#777">
                     <u>See more</u>
                  </Text>
               </Link>
            </View>
         )}
      </>
   )
}

PeopleAsideBlock.propTypes = {
   badgeId: PropTypes.string
}

PeopleAsideBlock.defaultProps = {
   badgeId: undefined
}

export default PeopleAsideBlock
